<!--
 * @Author: your name
 * @Date: 2021-04-01 16:18:32
 * @LastEditTime: 2021-04-02 12:48:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/AddressInput/index.vue
-->
<style lang="sass" scoped>
.mu-input
  width: 100%
</style>

<template>
  <mu-text-field
    id="form_address"
    v-on="$listeners"
    v-bind="$attrs"
    label="Your delivery address"
    label-float
  />
</template>

<script>
import {
  mapState,
} from 'vuex'
export default {
  props: {
    address: String,
    oldRawAddress: String,
    oldAddress: String,
    oldPostcode: String,
    postcode: [String, Number],
    rawAddress: [String, Object],
  },

  data() {
    return {
      addressAutoComplete: null,
    }
  },
  computed: {
    ...mapState({
      venueCountry: state => state.venueHome.venueCountry,
    })
  },

  mounted() {
    this.addressAutoComplete = new window.google.maps.places.Autocomplete(
      /** @type {!HTMLInputElement} */
      (document.querySelector('#form_address')),
      {
        types: ['geocode'],
        componentRestrictions: { country: this.venueCountry }
      }
    )
    this.addressAutoComplete.addListener('place_changed', this.fillInAddress)
  },

  destroyed() {
    if (this.addressAutoComplete) {
      this.addressAutoComplete.unbindAll()
    }
  },

  methods: {
    fillInAddress() {
      const rawAddress = this.addressAutoComplete.getPlace()
      this.$emit('update:rawAddress', JSON.stringify(rawAddress))
      const { address_components, formatted_address } = rawAddress
      let postcode = 'null'
      address_components.forEach(address => {
        if (address.types && address.types.includes('postal_code')) {
          postcode = address.short_name
        }
      })
      this.$emit('update:postcode', postcode)
      this.$emit('update:oldRawAddress', JSON.stringify(rawAddress))
      this.$emit('update:oldAddress', formatted_address)
      this.$emit('update:oldPostcode', postcode)
      this.$emit('update:address', formatted_address)
      this.$emit('submitUserAddress')
    },
  },
}
</script>
